import { gsap } from "gsap";
// import { Timeline, Linear, Power0, Power1, Power2, Power3, Expo, Sine } from "gsap";
import { batch } from "react-redux";

import { zoomToScale, scaleToZoom } from '@/util/zoom.js';
import d3zoom from '@/util/d3zoom';


function cancelTweenZoom() {
    if (this.zoomTimeline) {
        this.zoomTimeline.clear();
        this.zoomTimeline.eventCallback("onUpdate", null);
    }
}

function tweenZoom(bounds, targetX, targetY, margin = 0) {
        // console.log('tweenZoom', targetZ, targetX, targetY);
        //cancel any previous
        this.cancelTweenZoom();

        const w = (bounds.maxX - bounds.minX);
        const h = (bounds.maxY - bounds.minY);
        const diag = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2));
        const screenDiag = Math.sqrt(Math.pow(this.props.width, 2) + Math.pow(this.props.height, 2));

        const scaleW = (this.props.width - 2*margin) / w;
        const scaleH = (this.props.height - 2*margin) / h;

        const targetScale = Math.min(scaleW, scaleH);//1/zoomToScale(x);  


        const startDiag = screenDiag / this.props.scale;
        const targetDiag = screenDiag / targetScale;


        const startPanX = this.props.panX;
        const startPanY = this.props.panY;
        const startZ = this.props.scale; //scaleToZoom(this.props.scale);
        // console.log('scale', this.props.scale, 'startZ', startZ);

        const offsetX = targetX !== undefined ? (this.props.panX - targetX) * startZ : this.props.panX - this.props.width/2;
        const offsetY = targetY !== undefined ? (this.props.panY - targetY) * startZ : this.props.panY - this.props.height/2;

        let p0 = [
            startPanX, startPanY, startDiag
        ];
        let p1 = [
            targetX, targetY, targetDiag
        ];

        let d3Transition = d3zoom(p0, p1);

        const duration = d3Transition.duration / 1000 / 5;

        // console.log('from to', p0, p1);
        // console.log('duration', duration);
        // console.log('t0', d3Transition(0));
        // console.log('t.5', d3Transition(0.5));
        // console.log('t1', d3Transition(1));
        
        if (duration <= 0) {
            return
        }

        this.zoomTimeline = new gsap.timeline({
            // useFrames: true,
            duration
        });
        this.zoomTimeline.prev_progress = 0;
        this.zoomTimeline.debug = 0;
        // this.
        const tween = {};

        this.zoomTimeline.fromTo(tween, duration, {
            // z: startZ,
            dummy: 0
        }, {
            ease: "none", // Linear.easeNone, // easeInOut, // Sine.easeInOut, // 
            dummy: 1
            // z: scaleToZoom(targetZ),
        }, 0);

        
        
        this.zoomTimeline.eventCallback("onUpdate", (tl, foo) => {
            console.log(tl.progress);
            console.log(foo);
            console.log(this);
            
            const progress = this.zoomTimeline.progress();

            const xition = d3Transition(progress);
            // console.log('xition', progress, xition);

            const x = xition[0];
            const y = xition[1];
            const z = screenDiag / xition[2] ;

            this.tweenZoomUpdate(x, y, z);
        }, ["{self}"]);
    }

    function tweenZoomToZ(targetZ, targetX, targetY, margin = 0) {
        // console.log('tweenZoom', targetZ, targetX, targetY);
        //cancel any previous
        this.cancelTweenZoom();

        const screenDiag = Math.sqrt(Math.pow(this.props.width, 2) + Math.pow(this.props.height, 2));

        const startDiag = screenDiag / this.props.scale;
        const targetDiag = screenDiag / targetZ;

        const startPanX = this.props.panX;
        const startPanY = this.props.panY;
        const startZ = this.props.scale; //scaleToZoom(this.props.scale);
        // console.log('scale', this.props.scale, 'startZ', startZ);

        const offsetX = targetX !== undefined ? (this.props.panX - targetX) * startZ : this.props.panX - this.props.width/2;
        const offsetY = targetY !== undefined ? (this.props.panY - targetY) * startZ : this.props.panY - this.props.height/2;

        let p0 = [
            startPanX, startPanY, startDiag
        ];
        let p1 = [
            targetX, targetY, targetDiag
        ];

        let d3Transition = d3zoom(p0, p1);

        const duration = d3Transition.duration / 1000 / 5;

        // console.log('from to', p0, p1);
        // console.log('duration', duration);
        // console.log('t0', d3Transition(0));
        // console.log('t.5', d3Transition(0.5));
        // console.log('t1', d3Transition(1));
        
        if (duration <= 0) {
            return
        }

        this.zoomTimeline = new gsap.timeline({
            // useFrames: true,
            duration
        });
        this.zoomTimeline.prev_progress = 0;
        this.zoomTimeline.debug = 0;
        // this.
        const tween = {};

        this.zoomTimeline.fromTo(tween, duration, {
            // z: startZ,
            dummy: 0
        }, {
            ease: "none", // Linear.easeNone, // easeInOut, // Sine.easeInOut, // 
            dummy: 1
            // z: scaleToZoom(targetZ),
        }, 0);

        
        
        this.zoomTimeline.eventCallback("onUpdate", (tl) => {
            console.log(tl)
            console.log(this)
            const progress = this.zoomTimeline.progress();

            const xition = d3Transition(progress);
            // console.log('xition', progress, xition);

            const x = xition[0];
            const y = xition[1];
            const z = screenDiag / xition[2] ;

            this.tweenZoomUpdate(x, y, z);
        }, ["{self}"]);
    }

function tweenZoomUpdate(x, y, z) {
    batch(()=>{
        this.props.setZoom(z);
        this.props.setPan(x, y);
    })
    //  console.log('tweenZoomUpdate', 'dxdy', x, y, z); 

    this.directed.scale = z;
    this.directed.x = x;
    this.directed.y = y;

    this.current.scale = z;
    this.current.x = x;
    this.current.y = y;

}

export default {
    tweenZoom,
    tweenZoomToZ,
    tweenZoomUpdate,
    cancelTweenZoom
}